module.exports = __webpack_public_path__ + "static/media/Dev Flow Horz.804306f3.png";